import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("fp_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If we're returning from Google OAuth, the AuthCallback page will handle
    // establishing the JWT — skip the /me pre-check so we don't race it.
    if (typeof window !== "undefined" && window.location.pathname === "/auth/callback") {
      setLoading(false);
      return;
    }
    const t = localStorage.getItem("fp_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then(r => {
      setUser(r.data);
      localStorage.setItem("fp_user", JSON.stringify(r.data));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("fp_token", r.data.access_token);
    localStorage.setItem("fp_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("fp_token", r.data.access_token);
    localStorage.setItem("fp_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("fp_token");
    localStorage.removeItem("fp_user");
    setUser(null);
  };

  // Re-fetch the current user (used after subscription changes so the
  // "requires-subscription" guard sees the new tier immediately).
  const refreshUser = async () => {
    if (!localStorage.getItem("fp_token")) return null;
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      localStorage.setItem("fp_user", JSON.stringify(r.data));
      return r.data;
    } catch { return null; }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
